import React from "react";
import Image from "@herb/components/Image";
import { trackTransferToShop, trackSelectPromotion } from "../../../utils/analytics";
import { getOutboundLinkRel } from "@herb/utils";
import "./index.css";
import { fallbackImages } from "../../../utils/constants";

const DispensaryDealCard = ({ deal, cardNum }) => {
  const content = deal?.contentDeals?.contentDeals;
  const dealLink = content?.dealLink;
  const { contentMobileImage, featuredImage } = deal;
  const rel = getOutboundLinkRel({ brand: content?.product?.brand_name || '' });

  return (
    <div className="dispensaryDealCard">
      <a
        className="dispensaryDealCardImageLink desktop"
        href={dealLink}
        target="_blank"
        rel={rel}
        onClick={() => {
          // Track promotion selection
          trackSelectPromotion({
            promotionName: deal?.title || 'Dispensary Deal',
            dealType: 'dispensary_deal',
            brand: '',
            category: ''
          });
          
          // Track transfer to shop
          trackTransferToShop({
            affiliateUrl: dealLink,
            contentType: 'deals_page',
            surfaceType: 'deal_card',
            productTitle: deal?.title || '',
            category: '',
            brand: ''
          });
        }}
      >
        <Image
          className="dispensaryDealCardImage"
          src={featuredImage?.node?.sourceUrl}
          width={1300}
        />
      </a>
      <a
        className="dispensaryDealCardImageLink mobile"
        href={dealLink}
        target="_blank"
        rel={rel}
        onClick={() => {
          // Track promotion selection
          trackSelectPromotion({
            promotionName: deal?.title || 'Dispensary Deal',
            dealType: 'dispensary_deal',
            brand: '',
            category: ''
          });
          
          // Track transfer to shop
          trackTransferToShop({
            affiliateUrl: dealLink,
            contentType: 'deals_page',
            surfaceType: 'deal_card',
            productTitle: deal?.title || '',
            category: '',
            brand: ''
          });
        }}
      >
        <>
          <Image
            className="dispensaryDealCardImage"
            src={contentMobileImage?.mobileImage?.sourceUrl}
            width={500}
          />
        </>
      </a>
    </div>
  );
};

export default DispensaryDealCard;
